import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default (value) => {
  const phoneNumber = parsePhoneNumberFromString(value);

  return phoneNumber !== undefined && phoneNumber.isValid() && phoneNumber.isPossible();
};
